import FieldPriority from "../../../../fields3/generic/priority/priority"
import FieldConfig from "../../../proto/field-config"
import Task from "../../../../model2/task/task"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import FieldTaskPriority_ViewProperty from "./render/view-property"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"
import FieldTaskPriority_ViewGroup from "./render/group/group";

export default class FieldTaskPriority extends FieldPriority {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                      = "Priority"
        this.label                          = "Priority"


        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

        this.renderComponents.viewProperty      = FieldTaskPriority_ViewProperty
        this.renderComponents.viewGroup         = FieldTaskPriority_ViewGroup
    }

    // ACCESS
    canEdit(model:Task) {
        return model.acl.canChangePriority
    }

    // Table

    tableCellOnValueChange = (item: ItemModelV2, value: any, manager: TasksViewManager) => {

        item.task.priority = value
        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(manager as TasksViewManager, this)

    }
}
